import { render, staticRenderFns } from "./DynamicPaneContainer.vue?vue&type=template&id=c2ec71dc&scoped=true"
import script from "./DynamicPaneContainer.vue?vue&type=script&lang=ts"
export * from "./DynamicPaneContainer.vue?vue&type=script&lang=ts"
import style0 from "./DynamicPaneContainer.vue?vue&type=style&index=0&id=c2ec71dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ec71dc",
  null
  
)

export default component.exports